import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { forecasts, trendSignals } from "@/mocks/forecast";

const levelTone: Record<string, string> = {
  预警: "bg-primary-500 text-background-50",
  发酵: "bg-secondary-500 text-foreground-950",
  信号: "bg-accent-500 text-background-50",
};

export default function SignalSection() {
  const hotList = [...forecasts].sort((a, b) => b.heat - a.heat).slice(0, 6);

  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="实时动态"
          title="趋势信号与热力榜"
          description="左侧是今天监测到的异常动向，右侧是当前热度最高的前瞻条目。信号越密集，事件被引爆的概率越高。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-7">
            <div className="rounded-lg border border-background-300 bg-background-50 p-5 md:p-7">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-base font-bold text-foreground-950">信号时间线</h3>
                <span className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className="h-2 w-2 animate-pulse-soft rounded-full bg-accent-500" />
                  实时监测
                </span>
              </div>

              <ol className="mt-6 space-y-5">
                {trendSignals.map((signal, index) => (
                  <Reveal as="li" key={signal.text} delay={index * 60} className="relative flex gap-4">
                    <div className="flex flex-col items-center">
                      <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[10px] font-bold ${levelTone[signal.level] || "bg-background-300 text-foreground-800"}`}>
                        {signal.level.slice(0, 1)}
                      </span>
                      {index < trendSignals.length - 1 && (
                        <span className="mt-1 w-px flex-1 bg-background-300" />
                      )}
                    </div>
                    <div className="pb-1">
                      <p className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                        <span className="font-semibold text-primary-600">{signal.level}</span>
                        <span>{signal.time}</span>
                      </p>
                      <p className="mt-1.5 text-sm leading-relaxed text-foreground-800">{signal.text}</p>
                    </div>
                  </Reveal>
                ))}
              </ol>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-lg border border-background-300 bg-background-50 p-5 md:p-7">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-base font-bold text-foreground-950">热度排行</h3>
                <Link to="/forecast" className="text-xs font-semibold text-primary-600 hover:text-primary-500">
                  完整榜单
                </Link>
              </div>
              <ol className="mt-4 divide-y divide-background-200">
                {hotList.map((item, index) => (
                  <li key={item.id}>
                    <Link to={`/forecast/${item.id}`} className="group flex items-start gap-4 py-3.5">
                      <span
                        className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                          index < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                        }`}
                      >
                        {index + 1}
                      </span>
                      <span className="flex flex-1 flex-col">
                        <span className="text-sm font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
                          {item.title}
                        </span>
                        <span className="mt-1 flex items-center gap-3 text-[11px] text-foreground-500">
                          <span>{item.categoryName}</span>
                          <span className="flex items-center gap-1">
                            <i className="ri-fire-line text-primary-500" />
                            {item.heat}
                          </span>
                        </span>
                      </span>
                    </Link>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}